export default "/assets/webshop/img/logo-horizontal.png?8782dbc82cbd56859eed7ec08e7ef21a";